import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Fonte self-hostet via @fontsource (npm) — ingen CDN-/tredjepartskald (GDPR).
// Inter = brødtekst (guardrail); Plex Condensed = display (hero-tal/ordmærke).
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/ibm-plex-sans-condensed/600.css";
import "@fontsource/ibm-plex-sans-condensed/700.css";
import "./styles/tokens.css";
import "./styles/base.css";

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("#root mangler i index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
